export default "__VITE_ASSET__B_CKaOC7__"